import { render, staticRenderFns } from "./catalog.vue?vue&type=template&id=b9f2f540&scoped=true&"
import script from "./catalog.vue?vue&type=script&lang=js&"
export * from "./catalog.vue?vue&type=script&lang=js&"
import style0 from "./catalog.vue?vue&type=style&index=0&id=b9f2f540&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f2f540",
  null
  
)

export default component.exports